export default __webpack_public_path__ + "static/media/demonologist_white_icon.9ea5a121.png";